import {Logger, StringUtil,} from '@services/index';
import {FileInfoVO,} from '@models/system-vo/file-info-vo'
import * as Encoding from 'encoding-japanese';
import {Injectable,} from '@angular/core';
/**
 * ファイルユーティリティー
 */
@Injectable({
  providedIn: 'root',
})
export class FileUtil {
  mediaTypeCsv = 'text/csv';
  mediaTypePdf = 'application/pdf';

  constructor(
    private stringUtil: StringUtil,
    private logger: Logger
  ) {}

  /**
   * [一般開発者利用可]
   * 変数からダウンロード
   * @param blob blob
   * @param fileName ファイル名
   */
  downloadBlob(blob: Blob, fileName: string): void {
    // aタグの生成
    const a = document.createElement('a');
    // レスポンスからBlobオブジェクト＆URLの生成
    const blobUrl = window.URL.createObjectURL(new Blob([blob,], {
      type: blob.type,
    }));
    // 上で生成したaタグをアペンド
    document.body.appendChild(a);
    // BlobオブジェクトURLをセット
    a.href = blobUrl;
    // ダウンロードさせるファイル名の生成
    a.download = fileName;
    // クリックイベント発火
    a.click();
    document.body.removeChild(a);
  }

    /**
   * [一般開発者利用可]
   * 変数をBase64変換
   * @param file Fileオブジェクト
   */
  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        }
      };
      reader.onerror = error => reject(error);
    });
  }

  /**
   * [一般開発者利用可]
   * BASE64変換
   * @param file ファイル
   */
  convertToBase64(file: Blob | File): Promise<string | ProgressEvent<FileReader>> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // IE,Chrome対応
        // IEだと、readAsDataURLの結果がNULL値となる為、readAsDataURLの結果を
        // replaceせずにそのままresolveへ返す。
        if (typeof reader.result === 'string' && this.stringUtil.isEmpty(reader.result)) {
          resolve(reader.result);
        }
        else if (typeof reader.result === 'string') {
          const base64 = reader.result.replace(/^data:.*;base64,/, '');
          resolve(base64);
        }
      };
      reader.onerror = error => reject(error);
    });
  }
  /**
   * [一般開発者利用可]
   * BASE64をダウンロードする
   * @param base64 BASE64
   * @param type ファイルタイプ
   * @param fileName ファイル名
   */
  downloadBase64(base64: string, type: string, fileName: string): void {
    const blob = this.convertToBlob(base64, type);
    this.downloadBlob(blob, fileName);
  }

   /**
   * [一般開発者利用可]
   * BASE64変換（ファイル変換）
   * @param fileDownload ダウンロードファイル情報
   */
  downloadFile(fileDownload: FileInfoVO) :void{
    // base64変換＆ファイルダウンロード
    try {
      this.downloadFileData(fileDownload.binData, fileDownload.fileName);
    } catch (err) {
      if (err instanceof RangeError) {
        this.logger.errorWithFreeText(
          'キャッシュサイズが上限に近い可能性があるため、キャッシュのクリアを行ってください。');
      }
      throw err;
    }
  }

   /**
   * [一般開発者利用可]
   * BASE64変換（ファイル変換）＆ダウンロード
   * @param fileDownload ダウンロードファイル情報
   */
   downloadFiletoBase64(fileDownload: FileInfoVO) :void{
    // base64変換＆ファイルダウンロード
    try {

      if (this.stringUtil.isEmpty(fileDownload.binData)) {
        return;
      }
      const arr = fileDownload.binData.split(',');
      const mime = arr[0].replace(/^data:/, '').replace(/:base64/, '');
      const base64 = arr[1];
      // convertToBlob
      const bin = atob(base64.substring(base64.search(/^[^,]+,/),base64.length));
      const buffer = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
      }
      // Blobを作成
     const blob = new Blob([buffer.buffer,], {type:
        mime,
      });

      this.downloadBlob(blob, fileDownload.fileName);

    } catch (err) {
      if (err instanceof RangeError) {
        this.logger.errorWithFreeText(
          'キャッシュサイズが上限に近い可能性があるため、キャッシュのクリアを行ってください。');
      }
      throw err;
    }
  }

  /**
   * [一般開発者利用可]
   * BASE64変換（ファイル変換）
   * @param binData ファイルバイナリデータ
   * @param fileName ファイル名
   */
   downloadFileData(binData: string, fileName: string) :void {
    if (this.stringUtil.isEmpty(binData)) {
      return;
    }
    const arr = binData.split(',');
    const mime = arr[0].replace(/^data:/, '').replace(/:base64/, '');
    const base64 = arr[1];

    this.downloadBase64(base64, mime, fileName);
  }

  /**
   * [一般開発者利用可]
   * Blob変換
   * @param base64 BASE64
   * @param type ファイルタイプ
   */
  convertToBlob(base64: string, type: string): Blob {
    const base64Data = base64.replace(/^[^,]+,/, '');
    const charLimit = 125000;
    let base64Recombined = '';
    let startIndex = 0;
    let endIndex;

    // データが長すぎる場合、base64を分けてそれぞれにreplaceを実行
    while (startIndex < base64Data.length) {
      // \r\nの間から切らないようにbase64を分ける
      endIndex = startIndex + charLimit > base64Data.length ?
        base64Data.length :
        base64Data.slice(startIndex + charLimit).search(/[^\r\n]/) + startIndex + charLimit;
      base64Recombined += base64Data.slice(startIndex, endIndex).replace(/\r?\n/g, '');
      startIndex = endIndex;
    }

    const bin = atob(base64Recombined);
    const buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    // Blobを作成
    let blob = null;
    blob = new Blob([buffer.buffer,], {
      type,
    });
    return blob;
  }

  /**
   * 検索結果をCSV・TSVに出力する
   * @param headerLabels ヘッダ
   * @param keySort 項目順番キー
   * @param data 行のデータ
   * @param mode ファイル出力モード
   * @param character Encodingタイプ
   * @param lineBreak ラインブレイク
   * @param fileName ファイル名
   */
  downloadLocalDataWithCSVorTSV(
    headerLabels: string[] | null,
    keySort: string[],
    data: Record<string, unknown>[],
    mode: 'CSV' | 'TSV' | 'LOG' | 'TXT',
    character: 'SJIS' | 'UTF',
    lineBreak: 'CRLF' | 'LF',
    fileName: string
    ) : void {
      const dataText: string[] = [];
      let lineSeparator: string | null = null;
      let content: string | null = null;
      let blob: Blob | null = null;

      // ラインブレイクを設定する
      switch (lineBreak) {
        case 'CRLF':
            lineSeparator = '\r\n';
            break;
        case 'LF':
            lineSeparator = '\n';
            break;
      }

      // 項目順番キーでデータを設定する
      data.forEach(item => {
        if (item != null) {
          let itemValue = '';

          keySort.forEach(key => {
            itemValue = itemValue + item[key] + ','
          });

          // 最後の「,」を削除する
          itemValue = itemValue.slice(0, -1);

          dataText.push(itemValue);
        }
      });

      // ヘッダがある場合、設定する
      if (headerLabels != null) {
        content = headerLabels.join(',') + lineSeparator + dataText.map(data => data).join(lineSeparator);
      } else {
        content = dataText.map(data => data).join(lineSeparator);
      }

      if (content === null) {
        return;
      }

      // ファイル名にファイルタイプを設定する
      switch (mode) {
        case 'CSV':
            fileName = fileName + '.csv';
            content = content.replace(/\t/g, ',');
            break;
        case 'TSV':
            fileName = fileName + '.tsv';
            content = content.replace(/,/g, '\t');
            break;
        case 'LOG':
            fileName = fileName + '.log';
            content = content.replace(/,/g, '\t');
            break;
        case 'TXT':
            fileName = fileName + '.txt';
            break;
      }

      // UTF8に変換する
      const utf8Array = new TextEncoder().encode( content );

      // UTF8をSJISに変換する
      const sjisArray = Encoding.convert(utf8Array, 'SJIS', 'UTF8');

      // Blobを設定する
      switch (character) {
        case 'SJIS':
          blob = new Blob( [ new Uint8Array( sjisArray ), ] );
            break;
        case 'UTF':
          blob = new Blob( [ new Uint8Array( utf8Array ), ] );
            break;
      }

      if (blob === null) {
        return;
      }

      // ファイルを出力する
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);

      // 出力するファイルにファイル名を設定する
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  }
}
